export class BankUtils {
  // 初始化 我方银行下拉
  static initOurBankAccountArray(view, allOurBankAccountArray, ourInvoiceTitleArray, title) {
    let ourBankAccountArray = []
    if (view.$store.getters.currentOffice.multiTitleBankMode && title) {
      if (allOurBankAccountArray && allOurBankAccountArray.length > 0) {
        const officeInvoiceTitle = ourInvoiceTitleArray.find(p => p.invoiceTitle === title)
        // 名称 未填写时，或是填写的是未维护的抬头时，银行 下拉 取 所有未绑定的抬头的银行；
        // 名称填写是已维护的抬头，但是抬头未绑定任何银行， 银行 下拉 取 所有未绑定的抬头的银行；
        // 名称填写是已维护的抬头，抬头已绑定银行， 银行 下拉 取 所有未绑定的抬头的银行，和已绑定当前抬头的 银行。
        ourBankAccountArray = allOurBankAccountArray.filter(p => !p.officeInvoiceTitleUuid || (officeInvoiceTitle && officeInvoiceTitle.uuid === p.officeInvoiceTitleUuid))
      }
    } else {
      ourBankAccountArray = allOurBankAccountArray
    }
    return ourBankAccountArray
  }

  // 带出 默认我方银行
  static bringDefaultOurBankAccount(view, ourBankAccountArray, ourInvoiceTitleArray, title, currency) {
    let targetBank = {}
    if (view.$store.getters.currentOffice.multiTitleBankMode) {
      if (ourBankAccountArray && ourBankAccountArray.length > 0) {
        const officeInvoiceTitle = ourInvoiceTitleArray.find(p => p.invoiceTitle === title)

        let targetBanks
        let candidateBanks // 兜底候选：匹配币种但不要求 defaultPayment
        if (officeInvoiceTitle == null) {
          // 名称 未填写时，或是填写的是未维护的抬头时，默认值 根据发票币种（优先取发票上的CHARGE_CURRENCY1，为空则取发票的CURRENCY） 去匹配 未绑定抬头的银行，找到默认的
          candidateBanks = ourBankAccountArray.filter(p => !p.officeInvoiceTitleUuid && p.currency === currency)
          targetBanks = candidateBanks.filter(p => p.defaultPayment)
        } else {
          const boundBanks = ourBankAccountArray.filter(p => p.officeInvoiceTitleUuid === officeInvoiceTitle.uuid)
          if (!boundBanks || boundBanks.length === 0) {
            // 名称填写是已维护的抬头，但是抬头未绑定任何银行，默认值 根据发票币种 去匹配 未绑定抬头的银行，找到默认的
            candidateBanks = ourBankAccountArray.filter(p => !p.officeInvoiceTitleUuid && p.currency === currency)
            targetBanks = candidateBanks.filter(p => p.defaultPayment)
          } else {
            // 名称填写是已维护的抬头，抬头已绑定银行， 默认值 根据发票币种、抬头 去 匹配已绑定当前抬头的 银行，找默认的
            candidateBanks = ourBankAccountArray.filter(p => p.officeInvoiceTitleUuid === officeInvoiceTitle.uuid && p.currency === currency)
            targetBanks = candidateBanks.filter(p => p.defaultPayment)
          }
        }
        // 优先取设置了默认付款标记的银行，没有则兜底取第一条匹配币种的银行
        if (targetBanks && targetBanks.length > 0) {
          targetBank = targetBanks[0]
        } else if (candidateBanks && candidateBanks.length > 0) {
          targetBank = candidateBanks[0]
        }
      }
    }
    return targetBank
  }
}
